import { fetchAuthSession, signOut } from 'aws-amplify/auth';

const API_URL = process.env.REACT_APP_API_URL;

async function getAuthHeaders() {
  try {
    const { tokens } = await fetchAuthSession();
    if (!tokens?.idToken) throw new Error('No active session');
    return { Authorization: `Bearer ${tokens.idToken.toString()}` };
  } catch {
    await signOut();
    throw new Error('SESSION_EXPIRED');
  }
}

async function handleResponse(res) {
  if (res.status === 401) {
    await signOut();
    throw new Error('SESSION_EXPIRED');
  }
  if (!res.ok) {
    try {
      const body = await res.json();
      throw new Error(body.error || `API error ${res.status}`);
    } catch (e) {
      if (e.message !== `API error ${res.status}`) throw e;
      throw new Error(`API error ${res.status}`);
    }
  }
  return res.json();
}

export async function apiGet(path) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, { headers });
  return handleResponse(res);
}

export async function apiPut(path, body) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PUT',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiPost(path, body) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiDelete(path) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${API_URL}${path}`, {
    method: 'DELETE',
    headers,
  });
  return handleResponse(res);
}
